const initialState = {};

function reducer(state = initialState, action) {
    if (action.type === 'APM_DEFAULT_WARRANTY_SUCCESS') {
        return action.payload;
    }

    return state;
}

export default reducer;
